export abstract class CoachBotPagesConfiguration {
  // Define a static dictionary of string key and string value
  public static CustomPageTitles: { [key: string]: string } = {}
  public static DefaultTitle = 'TeachTower for Math';
}
